if (!customElements.get('nss-cart-native-gift')) {
  class NssCartNativeGift extends HTMLElement {
    connectedCallback() {
      this.submit = event => this.addGift(event);
      this.addEventListener('submit', this.submit);
    }

    disconnectedCallback() {
      this.removeEventListener('submit', this.submit);
    }

    async addGift(event) {
      const form = event.target;
      if (!form.matches('.nss-cart-native-gift__form')) return;
      event.preventDefault();
      event.stopPropagation();
      if (this.busy) return;
      this.busy = true;
      const buttons = this.querySelectorAll('button[type="submit"]');
      buttons.forEach(button => { button.disabled = true; });
      const status = this.querySelector('[data-native-gift-status]');
      status.textContent = '';
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('Gift add failed');
        const cart = this.closest('nss-cart-template');
        if (typeof cart?.refreshCart === 'function') {
          await cart.refreshCart();
        } else {
          window.location.assign(root + 'cart');
        }
      } catch (error) {
        if (this.isConnected) {
          status.textContent = this.dataset.error;
          buttons.forEach(button => { button.disabled = false; });
        }
      } finally {
        this.busy = false;
      }
    }
  }
  customElements.define('nss-cart-native-gift', NssCartNativeGift);
}

